var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpened = function SvgEyeOpened(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 19c-3.315 0-6.57-2.17-9.795-6.393a1 1 0 0 1 0-1.214C5.43 7.17 8.685 5 12 5s6.57 2.17 9.795 6.393a1 1 0 0 1 0 1.214C18.57 16.83 15.315 19 12 19m0-2c2.434 0 5.019-1.634 7.73-5-2.711-3.366-5.296-5-7.73-5s-5.019 1.634-7.73 5c2.711 3.366 5.296 5 7.73 5",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOpened;